import { useEffect, useState } from 'react';
import { recruitingApi } from '../../../api/recruiting.js';

export default function Interviews() {
  const [items, setItems] = useState([]);
  const [applications, setApplications] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [scorecardFor, setScorecardFor] = useState(null);
  const [error, setError] = useState(null);

  function refresh() {
    setLoading(true);
    recruitingApi
      .listInterviews()
      .then((d) => setItems(d?.items || []))
      .catch((e) => setError(e.response?.data?.message || 'Failed to load'))
      .finally(() => setLoading(false));
  }
  useEffect(() => {
    refresh();
    recruitingApi.listApplications().then((d) => setApplications(d?.items || [])).catch(() => {});
  }, []);

  async function createInterview(e) {
    e.preventDefault();
    const form = e.currentTarget;
    const fd = new FormData(form);
    try {
      await recruitingApi.createInterview({
        applicationId: fd.get('applicationId'),
        mode: fd.get('mode') || null,
        scheduledAt: fd.get('scheduledAt') ? new Date(fd.get('scheduledAt')).toISOString() : null,
      });
      form.reset();
      setShowForm(false);
      refresh();
    } catch (err) {
      setError(err.response?.data?.message || 'Failed to schedule');
    }
  }

  async function addScorecard(e) {
    e.preventDefault();
    const form = e.currentTarget;
    const fd = new FormData(form);
    try {
      await recruitingApi.addScorecard(scorecardFor, {
        criterion: fd.get('criterion'),
        score: Number(fd.get('score')) || null,
        comment: fd.get('comment') || null,
      });
      form.reset();
      setScorecardFor(null);
    } catch (err) {
      setError(err.response?.data?.message || 'Failed to add scorecard');
    }
  }

  return (
    <section data-testid="recruiting-interviews-page" data-loading={loading ? 'true' : 'false'}>
      <header className="page-header">
        <div><h1>Interviews</h1><p className="muted">{items.length} scheduled</p></div>
        <button className="btn primary" data-testid="recruiting-interview-create" onClick={() => setShowForm((s) => !s)}>
          {showForm ? 'Close' : '+ Schedule Interview'}
        </button>
      </header>

      {error && <div className="alert error">{error}</div>}

      {showForm && (
        <form onSubmit={createInterview} className="card form-card grid-form">
          <label>Application
            <select name="applicationId" data-testid="recruiting-interview-application-select" required>
              <option value="">—</option>
              {applications.map((a) => <option key={a.id} value={a.id}>{a.candidate_name} · {a.requisition_title} ({a.stage})</option>)}
            </select>
          </label>
          <label>Mode
            <select name="mode" defaultValue="video"><option value="video">Video</option><option value="onsite">Onsite</option><option value="phone">Phone</option></select>
          </label>
          <label>Scheduled at<input name="scheduledAt" type="datetime-local" data-testid="recruiting-interview-datetime-input" /></label>
          <div className="full actions"><button className="btn primary" type="submit" data-testid="recruiting-interview-submit">Schedule</button></div>
        </form>
      )}

      <div className="card">
        <table className="data-table" data-testid="recruiting-interview-list">
          <thead><tr><th>Mode</th><th>Scheduled</th><th>Status</th><th>Interviewer</th><th></th></tr></thead>
          <tbody>
            {items.map((i) => (
              <tr key={i.id} data-testid={`recruiting-interview-row-${i.id}`}>
                <td>{i.mode || '—'}</td>
                <td>{i.scheduled_at ? new Date(i.scheduled_at).toLocaleString() : '—'}</td>
                <td><span className={`chip status-${i.status}`}>{i.status}</span></td>
                <td>{i.interviewer_name || '—'}</td>
                <td><button className="btn ghost" data-testid={`recruiting-scorecard-add-${i.id}`} onClick={() => setScorecardFor(i.id)}>+ Scorecard</button></td>
              </tr>
            ))}
            {!loading && items.length === 0 && <tr><td colSpan={5} className="muted">No interviews scheduled.</td></tr>}
          </tbody>
        </table>
      </div>

      {scorecardFor && (
        <form onSubmit={addScorecard} className="card form-card grid-form" data-testid="recruiting-scorecard-form">
          <h3 className="full">Scorecard</h3>
          <label>Criterion<input name="criterion" data-testid="recruiting-scorecard-criterion-input" required /></label>
          <label>Score (1-5)<input name="score" type="number" min="1" max="5" /></label>
          <label className="full">Comment<textarea name="comment" rows={2} /></label>
          <div className="full actions">
            <button className="btn" type="button" onClick={() => setScorecardFor(null)}>Cancel</button>
            <button className="btn primary" type="submit" data-testid="recruiting-scorecard-submit">Save</button>
          </div>
        </form>
      )}
    </section>
  );
}
